import React from 'react'

import { Link, withRouter } from 'react-router-dom';

import { Section, Text, Empty, Properties, InfosBar, Index, Firmware, SensorStatus } from 'components';
import { Button, Container, Icon, Segment } from 'semantic-ui-react';

import { ModalEditSensor, ModalOptions } from 'modals';

import { API } from 'services';

import { Typeof, Functions } from 'utils';

import moment from 'moment';

import './style.css';

class PaneInformations extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      showDissociateModal: false
    };

    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleEditModalClose = this.handleEditModalClose.bind(this);

    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);

    this.toggleDissociateModal = this.toggleDissociateModal.bind(this);
    this.handleDissociateModalClose = this.handleDissociateModalClose.bind(this);
  }

  toggleEditModal() {

    //Show modal
    this.setState({
      showEditModal: !this.state.showEditModal
    });

  }

  handleEditModalClose(update) {

    if (Typeof.object(update)) {

      this.props.onModelChange(update);
    }

    //Hide modal
    this.toggleEditModal();
  }

  toggleDeleteModal() {

    //Show modal
    this.setState({
      showDeleteModal: !this.state.showDeleteModal
    });

  }

  handleDeleteModalClose(result, setProcessing) {

    if (result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/sensors/${this.props.sensor.mac_address}`)
        .then((response) => {

          //Go back to sensors list
          this.props.history.push('/sensors');
        });

    } else {

      this.toggleDeleteModal();
    }
  }

  toggleDissociateModal() {

    //Show modal
    this.setState({
      showDissociateModal: !this.state.showDissociateModal
    });
  }

  handleDissociateModalClose(result, setProcessing) {

    if (result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/devices/${this.props.sensor.device}/sensors/${this.props.sensor.mac_address}`)
        .then(() => {

          this.props.onDissociate();

        }).finally(this.toggleDissociateModal);

    } else {

      this.toggleDissociateModal();
    }
  }

  render() {

    const { sensor } = this.props;
    let hasDevice = Typeof.number(sensor.device);

    let sensorProperties = [
      {
        name: 'Adresse MAC',
        value: <Text style={{"mono" : true}}>{Functions.formatMacAddress(sensor.mac_address)}</Text>
      },
      {
        name: 'État',
        value: <SensorStatus status={sensor.status} />
      },
      {
        name: () => {
          return (
            <React.Fragment>
              Valise

              {/* Dissociate link */}
              {hasDevice &&
                <Link className="link dissociate" onClick={this.toggleDissociateModal}>(Dissocier)</Link>
              }

            </React.Fragment>
          )
        },
        value: Typeof.number(sensor.device) ? <Link to={`/devices/${sensor.device}`}><Index value={sensor.device} /></Link> : <Icon name="warning sign" color="yellow" />
      }
    ];

    let sensorSynchronizedProperties = [
      {
        name: "Firmware",
        value: Typeof.string(sensor.firmware) ? <Firmware firmware={sensor.firmware} /> : <Empty />
      },
      {
        name: "Installé le",
        value: Typeof.string(sensor.update_date) ? moment(sensor.update_date).format('DD/MM/YYYY [à] HH:mm:ss') : <Empty />
      }
    ];

    return (
      <React.Fragment>

        {/* Informations */}
        <Container>

          <Section title="Informations" actions={[
            <Button icon="edit" circular onClick={this.toggleEditModal} key={0} />,
            <Button icon="trash" circular color="red" onClick={this.toggleDeleteModal} key={1} />
          ]}>

            <Properties properties={sensorProperties} />

          </Section>

          {/* <Divider horizontal>
            <Header as='h4'>
              <Icon name='sync alternate' />
              Informations synchronisées
            </Header>
          </Divider> */}

          {/* Synchronization */}
          <Segment>
            <Properties properties={sensorSynchronizedProperties} />

            <InfosBar mode="row">
              <span>{Typeof.string(sensor.last_sync) ? moment(sensor.last_sync).format('[Synchronisé le] DD/MM/YYYY [à] HH:mm:ss') : "Aucune synchronisation"}</span>
            </InfosBar>
          </Segment>

        </Container>

        {/* Delete warning modal */}
        {this.state.showDeleteModal &&
          <ModalOptions onClose={this.handleDeleteModalClose} icon="trash alternate" title="Suppression" message={(
            <span>
              Vous êtes sur le point de supprimer ce capteur.
              <br />
              <br />
              Voulez-vous continuer ?
            </span>
          )} options={ModalOptions.OPTIONS_YESCANCEL} />}

        {/* Edit modal */}
        {this.state.showEditModal &&
          <ModalEditSensor onClose={this.handleEditModalClose} sensor={sensor} />
        }

        {/* Dissociates warning modal */}
        {this.state.showDissociateModal &&
          <ModalOptions onClose={this.handleDissociateModalClose} icon="unlink" title="Dissocier" message={(
            <span>
              Vous êtes sur le point de dissocier ce capteur de la valise <Index value={sensor.device}/>.
              <br />
              Cette action aura pour effet d'invalider la configuration des capteurs de la valise concernée.
              <br />
              <br />
              Voulez-vous continuer ?
            </span>
          )} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(PaneInformations);
